export const getColor = (ranking?: number, green?: boolean) => {
    if (!ranking) {
        return '#D4B578'
    }

    const rank = +ranking
    if (green && rank > 0) {
        return '#10f48b'
    } else if (green && rank === 0) {
        return '#fff'
    } else if (rank >= 0) {
        return '#D4B578'
    } else if (rank < 0) {
        return '#EF4150'
    } else return '#D4B578'
}
